import React, { Component } from 'react';
import Slider from 'react-slick';
import '../../../node_modules/slick-carousel/slick/slick.css';
import '../../../node_modules/slick-carousel/slick/slick-theme.css';
import TestimFamily from '../../images/testimfamily.png';

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
};

const dotsSettings = {
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 7,
    slidesToScroll: 1,
    focusOnSelect: true,
};
class WhatParentsSay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nav1: null,
            nav2: null,
        };
    }

    componentDidMount() {
        this.setState({
            nav1: this.slider1,
            nav2: this.slider2,
        });
    }

    render() {
        return (
            <section className="page-section bg-secondary text-white testimsec">
                <h2 className="yellowtxt">What Parents Say</h2>
                <div
                    id="myCarousel"
                    className="carousel slide"
                    data-ride="carousel"
                >
                    <Slider
                        asNavFor={this.state.nav2}
                        ref={slider => (this.slider1 = slider)}
                        {...dotsSettings}
                        className="carousel-indicators"
                    >
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        
                    </Slider>
                    <Slider
                        {...settings}
                        asNavFor={this.state.nav1}
                        ref={slider => (this.slider2 = slider)}
                        className="carousel-inner"
                    >
                        <div className="item carousel-item active">
                            <p className="testimonial">
                            “Friendly. Clean. My kids love coming here. I appreciate having this as a safe option for my children to play. It is a safely enclosed area and I can set up in front to do work while being able to easily watch them.”</p>
                            <p className="overview">Alysan M.</p>
                        </div>
                        <div className="item carousel-item active">
                            <p className="testimonial">
                             “The owners are the kindest people in the world. Hidden gem for kids with autism indoor playground for children with ASD.”</p>
                            <p className="overview">Jessy C.</p>
                        </div>
                        <div className="item carousel-item active">
                            <p className="testimonial">
                            “The staff are helpful and kind. My five-year-old grandson loves coming any chance he gets. His mobility and balance have improved since he's been coming."</p>
                            <p className="overview">Moira G.</p>
                        </div>
                        <div className="item carousel-item active">
                            <p className="testimonial">
                            “Best place to leave your kids for a few hours. Great place for kids to be social and a super safe and environment. The best part is you don’t need to be here wile they play!! Leave them here for the whole day if you’d like."</p>
                            <p className="overview">Leandro B.</p>
                        </div>
                        <div className="item carousel-item active">
                            <p className="testimonial">
                            “The owners are very nice, will accommodate pretty much anything to make your experience a good one, love the multiple gross motor activity for all children and kids!"</p>
                            <p className="overview">Shari P.</p>
                        </div>
                        <div className="item carousel-item active">
                            <p className="testimonial">
                            “Best play area and best location! Just recently I had my daughter's birthday there and the owner, Howard, and his wife, were extremely helpful. The staff as well were very nice. I highly reccomend it as a play area and a birthday location for your LO."</p>
                            <p className="overview">Alyesh C.</p>
                        </div>
                        <div className="item carousel-item active">
                            <p className="testimonial">
                            “This place has been so important to our child over the past couple years, and he can't wait to return after this pandemic."</p>
                            <p className="overview">Laton P.</p>
                        </div>
                       
                    </Slider>
                    <img
                        className="quoteimg"
                        src={TestimFamily}
                        alt="Testimonials family"
                    />
                </div>
            </section>
        );
    }
}

export default WhatParentsSay;
